import React, { useContext } from "react";
import { CustomImagesContext } from "context";
import { Container, Subtitle, Title } from "../../components";
import bagWithCodeDefault from "./bag_w_code.png";
import CodeInput from "./CodeInput";
import { Button } from "../../components";
import { ArrowForward } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { CircularProgress, useTheme } from "@mui/material";

function InsertCode({
  handleSubmit,
  handleDefaultGreeting,
  setCode,
  code,
}: {
  handleSubmit: () => void;
  handleDefaultGreeting: () => Promise<void>;
  setCode: (code: string) => void;
  code: string;
}) {
  const CODE_LENGTH = 8;
  const { t } = useTranslation("TagDispenser");
  const [gettingDefaultGreeting, setGettingDefaultGreeting] =
    React.useState(false);
  const { images } = useContext(CustomImagesContext);

  const theme: any = useTheme();
  const styles = {
    button: {
      width: "100%",
      textTransform: theme.layout?.buttons?.textTransform || "none",
      height: "56px",
      maxWidth: 300,
      borderRadius:
        `${theme.shape?.buttons?.borderRadius} !important` || "12px !important",
      fontSize: "18px",
      fontWeight: 700,
    },
    defaultButton: {
      width: "100%",
      maxWidth: 300,
    },
  };
  const onSubmitDefaultGreeting = React.useCallback(async () => {
    setGettingDefaultGreeting(true);
    await handleDefaultGreeting();
  }, [handleDefaultGreeting]);

  const handleInputChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (!/^[a-zA-Z0-9]{0,8}$/.test(event.target.value)) return;
      setCode(event.target.value.slice(0, CODE_LENGTH));
    },
    []
  );
  const handleCodeSubmit = React.useCallback(() => {
    handleSubmit();
  }, [code, handleSubmit]);
  return (
    <Container theme={theme} style={{ backgroundImage: "unset" }}>
      <img
        src={images["bagWithCodeReceiver"] || bagWithCodeDefault}
        alt="bag-with-qr-tag"
        height="160px"
        style={{ marginBottom: "20px" }}
      />

      <Title variant="h5">{t("CodeAssociation.InsertCode.title")}</Title>
      <Subtitle sx={{ color: "black", fontSize: "16px" }} gutterBottom>
        {t("CodeAssociation.InsertCode.subtitle")}
      </Subtitle>
      <CodeInput
        sx={{ mb: 2 }}
        onChange={handleInputChange}
        value={code}
        onKeyDown={(e) => e.key === "Enter" && handleCodeSubmit()}
      />
      <Button
        disabled={code.length !== CODE_LENGTH}
        variant="contained"
        sx={{
          ...styles.button,
          mb: 2,
          backgroundColor: theme.palette.custom?.buttons
            ? theme.palette.custom.buttons.main
            : theme.palette.primary?.main,
          "&:hover": {
            backgroundColor:
              theme.palette.custom?.buttons.dark || theme.palette.primary.dark,
            color:
              theme.palette.custom?.buttons.textColorLight ||
              theme.palette.primary.contrastText,
          },
        }}
        onClick={handleCodeSubmit}
      >
        {t("CodeAssociation.InsertCode.actionPrimary")}
      </Button>
      {gettingDefaultGreeting ? (
        <CircularProgress />
      ) : (
        <Button
          disabled={Boolean(code)}
          sx={{ ...styles.defaultButton }}
          onClick={onSubmitDefaultGreeting}
          endIcon={<ArrowForward sx={{ mt: "2px" }} />}
        >
          {t("CodeAssociation.InsertCode.actionSecondary")}
        </Button>
      )}
    </Container>
  );
}

export default InsertCode;
